import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './Checkbox.css';

export default class Checkbox extends React.Component {
  render() {
    return (
      <input 
        type="checkbox"
        checked={this.props.checked}
        onChange={this.props.onChange}
        className={css['checkbox']}
        aria-label={this.props.questionName}
        id={`${this.props.studentId}-${this.props.questionName}`}
      />
    );
  }
}

Checkbox.propTypes = {
  studentId: SFEntityID.isRequired,
  studentName: PropTypes.string.isRequired,
  questionName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
};
